// --- Our Modules --------------------------------------------------------------------------------
import useAuth from "@/hooks/useAuth";
import useOrganization from "@/hooks/useOrganization";
import usePopup from "@/hooks/usePopup";
import { catalogRecordUrl } from "@/utils";
import SharePopup from "@/UI/popups/SharePopup";
// --- Logic --------------------------------------------------------------------------------------
/**
 * The public link to a project or a unit, opened in a popup ready to send.
 *
 * It lives in a hook rather than in each screen because three of them offer it and all three need
 * the same thing the record itself does not carry: **the company's own slug**, which is the first
 * segment of every catalog address and is only in the memberships.
 *
 * `isPublic` is the caller's to check. An unpublished record has no public page, and offering a
 * link that answers 404 is worse than not offering one.
 */
export default function useShare() {
    const addComp = usePopup((state) => state.addComp);
    const memberships = useAuth((state) => state.memberships);
    const organizationId = useOrganization((state) => state.organizationId);

    const slug = memberships.find((membership) => membership.organization._id === organizationId)?.organization.slug ?? "";

    const share = (title: string, projectSlug: string, unitNumber?: string | null) =>
        addComp({
            name: "share",
            Component: SharePopup,
            anim: "scale",
            details: { title, url: catalogRecordUrl(slug, projectSlug, unitNumber) },
        });

    return { canShare: !!slug, share };
}
